import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark-dark py-8 mt-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">GAME PARK</h3>
            <p className="text-gray-400 text-sm">
              Discover and play the best online games for free. Our platform offers a wide variety of games across different categories.
            </p>
          </div>
          
          <div>
            <h4 className="text-md font-semibold text-white mb-4">Categories</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/?category=Action" className="text-gray-400 hover:text-primary">Action</Link></li>
              <li><Link to="/?category=Adventure" className="text-gray-400 hover:text-primary">Adventure</Link></li>
              <li><Link to="/?category=Casual" className="text-gray-400 hover:text-primary">Casual</Link></li>
              <li><Link to="/?category=Puzzle" className="text-gray-400 hover:text-primary">Puzzle</Link></li>
              <li><Link to="/?category=Sport" className="text-gray-400 hover:text-primary">Sport</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-md font-semibold text-white mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/help" className="text-gray-400 hover:text-primary">Help Center</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-primary">FAQ</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-primary">Contact Us</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-primary">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-primary">Privacy Policy</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-md font-semibold text-white mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a href="https://facebook.com" className="text-gray-400 hover:text-primary">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.48 7.17h-4.19V5.04c0-1.03.68-1.27 1.16-1.27h2.96V0h-4.08c-4.52 0-5.54 3.39-5.54 5.56v1.61H6v3.85h2.79V20h5.5v-8.98h3.7l.49-3.85z"/>
                </svg>
              </a>
              <a href="https://twitter.com" className="text-gray-400 hover:text-primary">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.1 10.1 0 01-3.127 1.195 4.926 4.926 0 00-8.384 4.482 12.9 12.9 0 01-9.38-4.752 4.88 4.88 0 001.525 6.57 4.868 4.868 0 01-2.23-.616v.06a4.923 4.923 0 003.95 4.827 4.962 4.962 0 01-2.222.085 4.935 4.935 0 004.6 3.42 9.88 9.88 0 01-7.29 2.04 14 14 0 007.558 2.21c9.053 0 14-7.5 14-14 0-.21 0-.43-.02-.63a10.012 10.012 0 002.457-2.548z"/>
                </svg>
              </a>
              <a href="https://pinterest.com" className="text-gray-400 hover:text-primary">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.11-.937-.2-2.382.042-3.42.218-.936 1.407-5.965 1.407-5.965s-.36-.718-.36-1.78c0-1.668.967-2.913 2.17-2.913 1.023 0 1.518.769 1.518 1.69 0 1.03-.655 2.568-.994 3.995-.283 1.195.598 2.169 1.777 2.169 2.133 0 3.77-2.25 3.77-5.495 0-2.873-2.064-4.882-5.014-4.882-3.414 0-5.418 2.56-5.418 5.207 0 1.03.397 2.132.893 2.73.098.12.12.225.083.345-.09.375-.293 1.19-.333 1.357-.053.225-.172.27-.4.165-1.5-.698-2.426-2.888-2.426-4.642 0-3.787 2.742-7.25 7.92-7.25 4.16 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.632-2.746-1.372l-.748 2.848c-.27 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
                </svg>
              </a>
              <a href="https://instagram.com" className="text-gray-400 hover:text-primary">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-6 text-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Game Park. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 